import React, {Component} from 'react';
import {connect} from 'react-redux';
import {CardCarousel as Carousel} from '@homeaway/react-card-carousel';
import {AspectRatioCard} from '@homeaway/react-aspect-ratio-card';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import {TABLET_BREAKPOINT} from '../../../utils/constants';

export class CarouselComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            index: 0,
            isClient: false
        };

        this.handlePrevNext = this.handlePrevNext.bind(this);
    }

    componentDidMount() {
        this.setState({isClient: true});
    }

    componentWillReceiveProps(nextProps) {
        if (!isNaN(nextProps.focusIndex) && (nextProps.focusIndex !== null) && (this.props.focusIndex !== nextProps.focusIndex)) {
            this.handlePrevNext({}, nextProps.focusIndex || 0);
        }
    }

    getControlOffset = (aspectRatio) => {
        return (width, controlHeight) => {
            return AspectRatioCard.getControlOffset(width, controlHeight, aspectRatio);
        };
    }

    handlePrevNext(evt, newIndex) {
        this.setState({index: newIndex});
    }

    render() {
        const {
            children,
            titleMessage,
            isMobile,
            aspectRatio = '3x4',
            breakpoints = {
                '1600': 4,
                '1200': 4,
                '992': 4,
                '768': 4,
                '480': 3,
                '0': isMobile ? 2 : 4
            },
            getControlOffset = this.getControlOffset
        } = this.props;

        const scrolling = isMobile && this.state.isClient;

        return (
            <Carousel
                breakpoints={breakpoints}
                cardIndex={this.state.index}
                getControlOffset={getControlOffset(aspectRatio)}
                onNextClick={this.handlePrevNext}
                onPreviousClick={this.handlePrevNext}
                nextLabel={'Next'}
                paging
                previousLabel={'Previous'}
                title={titleMessage}
                scrolling={scrolling}
            >
                {children}
            </Carousel>);
    }
}

export function mapStateToProps(state) {
    return {
        isMobile: state.config.isMobile
    };
}

export const CardCarousel = connect(mapStateToProps)(determineIfMobile(CarouselComponent, TABLET_BREAKPOINT));

